/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateQueryableTableAssignmentsRequest } from '../../models/create-queryable-table-assignments-request';
import { GetAllQueryableTableAssignmentsResponse } from '../../models/get-all-queryable-table-assignments-response';

export interface CreateQueryableTableAssignments$Params {
  organizationId: string;
  authorizedParty: string;
  
    /**
     * List of queryable table IDs to assign.
     */
    body: CreateQueryableTableAssignmentsRequest
}

export function createQueryableTableAssignments(http: HttpClient, rootUrl: string, params: CreateQueryableTableAssignments$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAllQueryableTableAssignmentsResponse>> {
  const rb = new RequestBuilder(rootUrl, createQueryableTableAssignments.PATH, 'post');
  if (params) {
    rb.path('organizationId', params.organizationId, {});
    rb.path('authorizedParty', params.authorizedParty, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAllQueryableTableAssignmentsResponse>;
    })
  );
}

createQueryableTableAssignments.PATH = '/v1/organizations/{organizationId}/graphql/queryableTableAssignments/{authorizedParty}';
